import { Theme } from '@quillbot/design-system';
import { unitPX, UNITS } from 'src/researcher/styles';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const common_styles = {
  contentPadding: { p: unitPX(UNITS['1.5pt']), pt: unitPX(UNITS['3pt']) },
};

export const pageStyles = {
  maxPageWidth: {
    width: '100%',
    maxWidth: unitPX(UNITS['130pt']),
  },
  py: {
    py: unitPX(UNITS['3pt']),
  },
  px: {
    px: unitPX(UNITS['3pt']),
  },
  sliderPX: {
    px: unitPX(UNITS['20pt']),
  },
  headerBg: {
    backgroundColor: (theme: Theme) => theme.palette.grey[800],
  },
  listBg: {
    backgroundColor: (theme: Theme) => theme.palette.grey[50],
  },
};
